import { withAppCrashIfException } from 'epic';
import { combineEpics } from 'redux-observable';

import { addonManagementFormEnrichmentRequestedEpic } from './addonManagementFormEnrichmentRequestedEpic';
import { fetchAddonManagementFormsEpic } from './fetchAddonManagementFormsEpic';
import { loadFilterStateEpic, persistFilterStateEpic } from './filter/filterStateEpic';
import { addonManagementQueueEpics } from './pricingConflationEpics';
import { handleTradeAckEpic, requestTradeEpic } from './requestTradeEpic';

export const addonManagementFormEpic = () =>
  withAppCrashIfException(
    'addonManagementForm',
    combineEpics(
      withAppCrashIfException('fetchAddonManagementFormsEpic', fetchAddonManagementFormsEpic()),
      withAppCrashIfException(
        'addFormToQueueOnPricingRequestedEpic',
        addonManagementQueueEpics.addFormToQueueOnPricingRequestedEpic(),
      ),
      withAppCrashIfException('priceFormEpic', addonManagementQueueEpics.priceFormEpic()),
      withAppCrashIfException('quoteResultReceivedEpic', addonManagementQueueEpics.quoteResultReceivedEpic()),
      withAppCrashIfException('cancelQuotePushBackEpic', addonManagementQueueEpics.cancelQuotePushBackEpic()),
      withAppCrashIfException('abortQuoteEpic', addonManagementQueueEpics.abortQuoteEpic()),
      withAppCrashIfException(
        'AddonManagementFormEnrichmentRequestedEpic',
        addonManagementFormEnrichmentRequestedEpic(),
      ),
      withAppCrashIfException('handleTradeAckEpic', handleTradeAckEpic()),
      withAppCrashIfException('requestTradeEpic', requestTradeEpic()),
      withAppCrashIfException('persistFilterStateEpic', persistFilterStateEpic()),
      withAppCrashIfException('loadFilterStateEpic', loadFilterStateEpic()),
    ),
  );
